/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Contract, ContractFactory, testMethod, fetchContractState, ContractInstance, } from "@alephium/web3";
import { default as BridgeRewardRouterContractJson } from "../token_bridge/BridgeRewardRouter.ral.json";
class Factory extends ContractFactory {
    constructor() {
        super(...arguments);
        this.tests = {
            completeTransfer: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "completeTransfer", params);
            }),
            addRewards: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "addRewards", params);
            }),
        };
    }
    at(address) {
        return new BridgeRewardRouterInstance(address);
    }
}
// Use this object to test and deploy the contract
export const BridgeRewardRouter = new Factory(Contract.fromJson(BridgeRewardRouterContractJson, "", "213e716a4d9125a71678f579c770a9721e5d4b1c95822f2f623f3ae27cc0f76b"));
// Use this class to interact with the blockchain
export class BridgeRewardRouterInstance extends ContractInstance {
    constructor(address) {
        super(address);
    }
    fetchState() {
        return __awaiter(this, void 0, void 0, function* () {
            return fetchContractState(BridgeRewardRouter, this);
        });
    }
}
